<template>
  <pt-integral-task-form class="pt-integral-task-form__page"></pt-integral-task-form>
</template>

<script>
import PtIntegralTaskForm from 'cps/integral-mall-manage/pt-integral-task/pt-integral-task-form/withData'
export default {
  name: 'pt-integral-task-form__view',
  components: {
    'pt-integral-task-form': PtIntegralTaskForm
  }
}
</script>
